import React from 'react';
import { useText } from '../../lib/siteContent';
import { motion } from 'framer-motion';
import { responsiveImg } from '../../lib/imageUrl';
import { useSlotImage } from '../../lib/useSlotImage';

const VALUES = [
  { n: '01', title: 'Écoute', desc: 'Comprendre l’histoire, les attentes et l’intention.' },
  { n: '02', title: 'Beauté', desc: 'Composer avec mesure, émotion et caractère.' },
  { n: '03', title: 'Maîtrise', desc: 'Anticiper et conduire chaque étape avec précision.' },
  { n: '04', title: 'Harmonie', desc: 'Unir le lieu, l’esthétique et l’expérience.' },
];

const reveal = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: '-60px' },
  transition: { duration: 1, ease: [0.22, 1, 0.36, 1] },
};

const FoundersImage = () => {
  const src = useSlotImage('maison-fondateurs', null);
  return (
    <div className="w-full aspect-[4/5] lg:aspect-[3/4] overflow-hidden bg-[#F5F5F5] flex items-center justify-center" data-testid="founders-image-area">
      {src ? (
        <img {...responsiveImg(src, '(max-width: 768px) 100vw, 50vw')} alt="Mamadu et Halima, fondateurs de JBMH Events" className="w-full h-full object-cover" data-testid="founders-image" />
      ) : (
        <span className="text-[10px] uppercase tracking-[0.3em] text-[#6B6B6B]" data-testid="founders-placeholder">Photo des fondateurs à venir</span>
      )}
    </div>
  );
};

const NotreHistoire = () => {
  const t = useText();
  return (
  <section id="notre-histoire" className="bg-[#FFFFFF] border-t border-[#111111]/10 py-28 md:py-40" data-testid="notre-histoire-section">
    <div className="container-custom grid grid-cols-1 lg:grid-cols-[7fr_5fr] gap-16 lg:gap-20 xl:gap-28">
      <div>
        <motion.span {...reveal} className="block text-[11px] uppercase tracking-[0.3em] text-[#111111] mb-10" data-testid="histoire-label">
          {t('histoire.label')}
        </motion.span>
        <motion.h2 {...reveal} className="font-serif font-light text-[#111111] text-4xl sm:text-5xl leading-[1.08]" data-testid="histoire-headline">
          <span className="whitespace-pre-line">{t('histoire.headline')}</span>
        </motion.h2>
        <motion.p {...reveal} className="mt-10 md:mt-12 text-sm md:text-base leading-[1.9] font-light text-[#333333] max-w-xl" data-testid="histoire-story">
          {t('histoire.story')}
        </motion.p>
        <motion.blockquote {...reveal} className="mt-14 border-l border-[#111111]/30 pl-6 md:pl-8 max-w-xl" data-testid="histoire-quote">
          <p className="font-serif font-light italic text-[#111111] text-2xl md:text-[1.9rem] leading-[1.35]">
            {t('histoire.quote')}
          </p>
        </motion.blockquote>
        <div className="mt-20 grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-12" data-testid="histoire-values">
          {VALUES.map((v, i) => ({ ...v, title: t(`histoire.v${i + 1}.title`), desc: t(`histoire.v${i + 1}.desc`) })).map((v) => (
            <div key={v.n} className="border-t border-[#111111]/15 pt-7" data-testid={`value-${v.n}`}>
              <span className="block text-[11px] tracking-[0.3em] text-[#6B6B6B]">{v.n}</span>
              <h3 className="mt-4 font-serif font-light text-[#111111] text-2xl md:text-[1.7rem]">{v.title}</h3>
              <p className="mt-3 text-sm leading-[1.85] font-light text-[#333333]">{v.desc}</p>
            </div>
          ))}
        </div>
      </div>
      <div className="lg:sticky lg:top-32 self-start">
        <FoundersImage />
      </div>
    </div>
  </section>
  );
};

export default NotreHistoire;
